import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Input,
} from "reactstrap";
import "./common.styles.scss";

import { useDispatch, useSelector } from "react-redux";
import { siteWideSearch } from "../../store/siteSearch/action";

import { isEmpty } from "lodash";
import ClickOutside from "./ClickOutsideComponent";
import { groupsPresentIn, metaFor } from "./searchEntityMeta";

// Navigate to the full advanced search page, carrying the current term over.
const goToAdvancedSearch = (history, query, onDone) => {
  const q = (query || "").trim();
  history.push(`/advanced-search${q ? `?q=${encodeURIComponent(q)}` : ""}`);
  if (onDone) onDone();
};

const SearchOption = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [searchData, setSearchData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showResults, setShowResults] = useState(false);

  const { SiteSearchData } = useSelector((state) => ({
    SiteSearchData: state.SiteSearch.siteWideSearchList?.search_list,
  }));

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchQuery.length > 0) {
        dispatch(siteWideSearch({ id: searchQuery }));
        setShowResults(true);
      } else {
        setShowResults(false);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    setSearchData(SiteSearchData);
    if (SiteSearchData?.length > 0) {
      setShowResults(true);
    } else {
      setShowResults(false);
    }
  }, [SiteSearchData]);

  return (
    <React.Fragment>
      <div className={"search-company-wide-widget-main-frame"}>
        <ClickOutside
          onClick={() => {
            setShowResults(false);
          }}
        >
          <form
            className={"search-company-wide-input-box"}
            onSubmit={(e) => {
              e.preventDefault();
              goToAdvancedSearch(history, searchQuery, () =>
                setShowResults(false)
              );
            }}
          >
            <Input
              autoComplete={"off"}
              type="search"
              className="site-wide-search-input"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
              }}
              onFocus={() => {
                if (searchQuery.length > 0) {
                  setShowResults(true);
                }
              }}
            />
          </form>
          {showResults && (
            <SearchResultsContent
              searchData={searchData}
              searchQuery={searchQuery}
              setShowResults={setShowResults}
            />
          )}
        </ClickOutside>
      </div>
    </React.Fragment>
  );
};

export default SearchOption;

export const SearchOptionMobile = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [searchData, setSearchData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showResults, setShowResults] = useState(false);

  const { SiteSearchData } = useSelector((state) => ({
    SiteSearchData: state.SiteSearch.siteWideSearchList?.search_list,
  }));

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchQuery.length > 0) {
        dispatch(siteWideSearch({ id: searchQuery }));
        setShowResults(true);
      } else {
        setShowResults(false);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    setSearchData(SiteSearchData);
    if (SiteSearchData?.length > 0) {
      setShowResults(true);
    } else {
      setShowResults(false);
    }
  }, [SiteSearchData]);

  const [search, setSearch] = useState(false);
  const toogleSearch = () => {
    setSearch(!search);
  };

  return (
    <>
      <Dropdown
        isOpen={search}
        toggle={toogleSearch}
        className="d-md-none topbar-head-dropdown header-item"
      >
        <DropdownToggle
          type="button"
          tag="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
        >
          <i className="bx bx-search fs-22"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div>
            <form
              className="form-group m-0"
              onSubmit={(e) => {
                e.preventDefault();
                goToAdvancedSearch(history, searchQuery, () => {
                  setShowResults(false);
                  toogleSearch();
                });
              }}
            >
              <div className="input-group">
                <Input
                  autoComplete={"off"}
                  type="search"
                  className="site-wide-search-input"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                  onFocus={() => {
                    if (searchQuery.length > 0) {
                      setShowResults(true);
                    }
                  }}
                />
              </div>
            </form>
          </div>
          <div>
            {showResults && (
              <SearchResultsContent
                searchData={searchData}
                searchQuery={searchQuery}
                toogleSearch={toogleSearch}
                setShowResults={setShowResults}
              />
            )}
          </div>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

const ALL_GROUP = "all";

function SearchResultsContent({
  searchData,
  searchQuery,
  setShowResults,
  toogleSearch,
}) {
  const [selectedGroup, setSelectedGroup] = useState(ALL_GROUP);

  // Categories present in the current result set, ordered + counted.
  const groupsPresent = useMemo(
    () => groupsPresentIn(searchData),
    [searchData]
  );

  // Reset the active pill whenever a fresh result set arrives so we never leave a
  // stale category selected after the term changes.
  useEffect(() => {
    setSelectedGroup(ALL_GROUP);
  }, [searchData]);

  const filtered = useMemo(() => {
    if (selectedGroup === ALL_GROUP) return searchData || [];
    return (searchData || []).filter((item) => item?.ZGroup === selectedGroup);
  }, [searchData, selectedGroup]);

  const closeResults = () => {
    setShowResults(false);
    if (toogleSearch) toogleSearch();
  };

  const advancedSearchTo = `/advanced-search${
    searchQuery ? `?q=${encodeURIComponent(searchQuery)}` : ""
  }`;

  return (
    <div className={"search-result-main-box-wrapper"}>
      <div className={"search-result-main-frame"}>
        {/* Category pills - click to filter the results in-place */}
        {!isEmpty(groupsPresent) ? (
          <div className="search-company-wide-pill-row">
            <button
              type="button"
              className={
                "search-company-wide-pill" +
                (selectedGroup === ALL_GROUP ? " is-active" : "")
              }
              onClick={() => setSelectedGroup(ALL_GROUP)}
            >
              <i className="ri-apps-2-line" />
              <span>All</span>
              <em>{searchData?.length || 0}</em>
            </button>
            {groupsPresent.map((g) => (
              <button
                type="button"
                key={g.group}
                className={
                  "search-company-wide-pill" +
                  (selectedGroup === g.group ? " is-active" : "")
                }
                onClick={() => setSelectedGroup(g.group)}
              >
                <i className={g.icon} />
                <span>{g.label}</span>
                <em>{g.count}</em>
              </button>
            ))}
          </div>
        ) : null}

        {/* Result rows for the active category */}
        {!isEmpty(filtered) ? (
          <div>
            {filtered.map((item, index) => (
              <Link
                key={`${item?.ZGroup}-${item?.Id}-${index}`}
                to={item?.Url || "#"}
                className="dropdown-item notify-item"
                onClick={closeResults}
              >
                <i
                  className={
                    (item?.ZIcon || metaFor(item?.ZGroup).icon) +
                    " align-middle fs-18 text-muted me-2"
                  }
                ></i>
                <span>{item?.ObjectData}</span>
              </Link>
            ))}
          </div>
        ) : (
          <div className="dropdown-item text-muted">No matching results</div>
        )}

        {/* Footer - jump to the full advanced search page, carrying the term over */}
        <div className="search-company-wide-footer">
          <Link to={advancedSearchTo} onClick={closeResults}>
            <i className="ri-search-eye-line me-1" />
            Advanced search
          </Link>
        </div>
      </div>
    </div>
  );
}
